import React from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';

const ParentCardNoCol = ({
  children,
  title,
  icon,
  headerLink,
  headerTitle,
  headerText,
  CtaComponent,
  generateComponentButton,
  bgColor,
  isSearch,
  updateSearchTerm,
  handleSearch,
  btnSize = 'sm',
}) => {
  return (
    <div className="card">
      <div
        className="card-header card-header-icon"
        data-background-color={`${bgColor ? bgColor : 'drapcode-dark-blue'}`}
      >
        <i className={`wb ${drapcodeIcon(icon)}`}></i>
      </div>
      <div className="card-content">
        <div className="card-title-header">
          <h4 className="card-title">{title}</h4>
          <div className="card-cta">
            {generateComponentButton}
            {CtaComponent
              ? CtaComponent
              : headerLink && (
                  <Link to={headerLink} className="btn btn-theme-submit btn-md" title={headerTitle}>
                    <i className="wb webconnect-plus" /> {headerText}
                  </Link>
                )}
          </div>
        </div>
        {isSearch && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
            className="form-inline mb-2 d-flex justify-content-between"
          >
            <input
              type="text"
              placeholder="Search..."
              className="form-control col-11"
              onChange={(e) => {
                updateSearchTerm(e.target.value);
              }}
            />
            <button
              type="submit"
              title={`Search ${title}`}
              className={`btn btn-primary ${
                btnSize === 'md' ? 'btn-md' : btnSize === 'lg' ? 'btn-lg' : 'btn-sm'
              }`}
            >
              <i className={`wb ${drapcodeIcon('search')}`}></i>
            </button>
          </form>
        )}
        {children}
      </div>
    </div>
  );
};

export default ParentCardNoCol;
